import {
  edecideApiDev,
  edecideApiLocal,
  edecideApiProd,
  edecideApiTest,
  edecideCnameDev,
  edecideCnameProd,
  edecideCnameTest,
  edecideSpaDev,
  edecideSpaLocal,
  edecideSpaProd,
  edecideSpaTest,
} from "ApiEdecideEnvironments";
import { siveSpaDev, siveSpaLocal, siveSpaProd, siveSpaTest } from "ApiSiveEnvironments";

export interface Environment {
  clientId: string;
  applicationIdUrl: string;
  tenantId: string;
  backendUrl: string;
  frontendUrl: string;
  siveUrl: string;
  staticWebAppUrl: string;
  name: string;
  shortName: string;
}

const tenantId = "2cda5d11-f0ac-46b3-967d-af1b2e1bd01a";
const appInt = {
  clientId: "8ddf488d-c6df-4dff-b00b-cb2b92ea5be3",
  applicationIdUrl: "https://sbb.onmicrosoft.com/int-edecide-identity",
  tenantId,
};

const appProd = {
  clientId: "d5f39488-9c1a-446c-adb5-5bb8ef799946",
  applicationIdUrl: "https://sbb.onmicrosoft.com/edecide-identity",
  tenantId,
};

const local: Environment = {
  ...appInt,
  backendUrl: edecideApiLocal,
  frontendUrl: edecideSpaLocal,
  siveUrl: siveSpaLocal,
  staticWebAppUrl: "",
  name: "Localhost",
  shortName: "local",
};

const dev: Environment = {
  ...appInt,
  backendUrl: edecideApiDev,
  frontendUrl: edecideCnameDev,
  siveUrl: siveSpaDev,
  staticWebAppUrl: edecideSpaDev,
  name: "Develop",
  shortName: "dev",
};

const test: Environment = {
  ...appInt,
  backendUrl: edecideApiTest,
  frontendUrl: edecideCnameTest,
  siveUrl: siveSpaTest,
  staticWebAppUrl: edecideSpaTest,
  name: "Test",
  shortName: "test",
};

const prod: Environment = {
  ...appProd,
  backendUrl: edecideApiProd,
  frontendUrl: edecideCnameProd,
  siveUrl: siveSpaProd,
  staticWebAppUrl: edecideSpaProd,
  name: "Production",
  shortName: "prod",
};

function matchEnv(env: Environment) {
  const origin = window.location.origin;
  return origin == env.frontendUrl || origin == env.staticWebAppUrl;
}

export let environment: Environment;
if (matchEnv(local)) {
  console.trace(`env: local`);
  environment = local;
} else if (matchEnv(dev)) {
  console.trace(`env: dev`);
  environment = dev;
} else if (matchEnv(test)) {
  console.trace(`env: test`);
  environment = test;
} else if (matchEnv(prod)) {
  console.trace(`env: prod`);
  environment = prod;
} else {
  console.trace(`env: origin '${window.location.origin}' is unhandled, falling back to 'dev'`);
  environment = dev;
}

export function getDisplayName() {
  switch (environment.name) {
    case "Localhost":
      return "Local";
    case "Develop":
      return "Dev";
    case "Test":
      return "Test";
    case "Production":
    default:
      return "";
  }
}

export function getTooltip() {
  switch (environment.name) {
    case "Localhost":
      return "Sie befinden sich auf der\nEntwicklungsumgebung (localhost).";
    case "Develop":
      return "Sie befinden sich in der\nEntwicklungsumgebung.";
    case "Test":
      return "Sie befinden sich in der\nTestumgebung.";
    case "Production":
    default:
      return "";
  }
}

export function getApplicationName(name: string) {
  const envDisplayName = getDisplayName();
  return name + (envDisplayName ? ` (${envDisplayName})` : "");
}
